import { useState, useEffect } from 'react'
import { showTemple, getIsNonReligiousMode } from '@fs/zion-permissions'

export const validBuildTemplePageLangForLocale = {
  bg: 'eng',
  cs: 'eng',
  da: 'eng',
  de: 'deu',
  el: 'eng',
  en: 'eng',
  es: 'spa',
  et: 'eng',
  fi: 'eng',
  fj: 'eng',
  fr: 'fra',
  hr: 'eng',
  ht: 'eng',
  hu: 'eng',
  hy: 'eng',
  id: 'eng',
  is: 'eng',
  it: 'ita',
  ja: 'jpn',
  km: 'eng',
  ko: 'kor',
  lt: 'eng',
  lv: 'eng',
  mk: 'eng',
  mn: 'eng',
  ms: 'eng',
  nl: 'eng',
  no: 'eng',
  pl: 'eng',
  pt: 'por',
  ro: 'eng',
  ru: 'rus',
  sk: 'eng',
  sl: 'eng',
  sm: 'eng',
  sq: 'sqi',
  sr: 'eng',
  sv: 'eng',
  th: 'eng',
  to: 'eng',
  tr: 'eng',
  uk: 'eng',
  vi: 'eng',
  zh: 'zho',
}

export const useIsAuthorizedToViewTemple = () => {
  const [state, setState] = useState({ loading: true, state: undefined, error: undefined })

  useEffect(() => {
    let isMounted = true
    Promise.all([showTemple(), getIsNonReligiousMode()])
      .then(([canAccessTemple, isNonReligiousMode]) => {
        if (isMounted) {
          setState({ state: { canAccessTemple, isNonReligiousMode }, loading: false, error: undefined })
        }
        return undefined
      })
      .catch(() => {
        if (isMounted) {
          setState({ state: {}, loading: false, error: true })
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return state
}
